import {Flex, Text} from '@chakra-ui/react';
import {FC} from 'react';
import {TranslationKeys} from 'translations';
import NextImageUI from 'ui/NextImage';

interface IProps {
  t: (term: TranslationKeys) => string;
}

export const SocialNetwork: FC<IProps> = ({t}) => {
  return (
    <a href="https://www.instagram.com/straus.md/" target="_blank" rel="noreferrer">
      <Flex alignItems="center" mt="15px">
        <Text mr="15px" fontSize={['12px', '16px']}>
          {t('FOLLOW_US_ON')}
        </Text>

        <NextImageUI src="/icons/icon-instagram.svg" alt="icon" width={24} height={24} />
      </Flex>
    </a>
  );
};
